import { render, staticRenderFns } from "./videoList2.vue?vue&type=template&id=b3c947ec&scoped=true&"
import script from "./videoList2.vue?vue&type=script&lang=js&"
export * from "./videoList2.vue?vue&type=script&lang=js&"
import style0 from "./videoList2.vue?vue&type=style&index=0&id=b3c947ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c947ec",
  null
  
)

export default component.exports